
export class CardFlag {
    colour: string;
    text: string;

}